import { gql } from '../__generated__';

export const GET_USAGE_LIMITS = gql(`
  query GetUsageLimits {
    usageLimits: getUsageLimits {
      id
      sourceId
      subscriptionIds
      licenseId
      licenseName
      userId
      userName
      maxDocuments
      documentWindowDays
      maxAiTokens
      aiTokenWindowDays
      usageResetAt
      active
      lastUpdatedAt
    }
  }
`);

export const GET_USER_USAGE_STATUS = gql(`
  query GetUserUsageStatus($userId: Int!) {
    usageStatus: getUserUsageStatus(userId: $userId) {
      userId
      products {
        sourceId
        documentsUsed
        maxDocuments
        documentWindowDays
        aiTokensUsed
        maxAiTokens
        aiTokenWindowDays
        lastDocumentResetAt
        lastAiResetAt
        inEffectRuleScope
        globalMaxDocuments
        globalDocumentWindowDays
        globalMaxAiTokens
        globalAiTokenWindowDays
      }
    }
  }
`);

export const CREATE_USAGE_LIMIT = gql(`
  mutation CreateUsageLimit($input: CreateUsageLimitInput!) {
    createUsageLimit(input: $input) {
      id
    }
  }
`);

export const UPDATE_USAGE_LIMIT = gql(`
  mutation UpdateUsageLimit($input: UpdateUsageLimitInput!) {
    updateUsageLimit(input: $input) {
      id
      maxDocuments
      documentWindowDays
      maxAiTokens
      aiTokenWindowDays
      active
    }
  }
`);

export const DELETE_USAGE_LIMIT = gql(`
  mutation DeleteUsageLimit($input: DeleteUsageLimitInput!) {
    deleteUsageLimit(input: $input)
  }
`);

export const RESET_USER_USAGE = gql(`
  mutation ResetUserUsage($input: ResetUserUsageInput!) {
    resetUserUsage(input: $input)
  }
`);
